import CustomTable from "../../CustomTable";
import { Link } from "react-router-dom";
import { plusicon } from "../../imagepath";
import { DownloadIcon } from "../../CustomStyle";
const Sintomas = () => {
  const datasource = null;

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id.localeCompare(b.ID),
      searchable: true,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.Name),
      searchable: true,
    },
    {
      title: "Age",
      dataIndex: "age",
      key: "age",
      sorter: (a, b) => a.age.localeCompare(b.Age),
      searchable: true,
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
      sorter: (a, b) => a.address.localeCompare(b.Address),
      searchable: true,
    },
  ];

  const rowSelection = {
  };
  return (
    <div className="card">
      <div className="card-header pb-0">
        <h4 className="card-title d-inline-block">Síntomas del paciente </h4>{" "}
      </div>
      <CustomTable
        dataSource={datasource}
        columns={columns}
        rowSelection={rowSelection}
        updateDataSource={() => {}}
      />
    </div>
  );
};

export default Sintomas;
